import * as settings from '../settings';
import React, { Component } from 'react';
import { Map as MapContext, View, Feature } from 'ol';
import { Tile, Vector as LayerVector } from 'ol/layer';
import { fromLonLat } from 'ol/proj';
import { OSM, Vector as SourceVector } from 'ol/source';
import { Style, Icon, Circle, Fill, Stroke } from 'ol/style'
import { Point, LineString } from 'ol/geom'

import 'ol/ol.css';

class Map extends Component {
  constructor(props) {
    super(props);

    this.features = new SourceVector();
    this.map = new MapContext();
    this.map.addLayer(new Tile({
      source: new OSM({
        url: settings.OSM_URL,
      })
    }));
    this.map.addLayer(new LayerVector({
      source: this.features,
    }));
  }

  componentDidMount() {
    this.map.setTarget('map');
  }

  centerView() {
    const coords = [this.props.center.longitude, this.props.center.latitude]
    this.map.setView(new View({
      center: fromLonLat(coords),
      zoom: 16,
    }));
  }

  renderPolyline() {
    let locations = [];
    for (const [_, report] of this.props.reports.entries()) {
      locations.push([report.longitude, report.latitude]);
    }

    let polyline = new LineString(locations);
    polyline.transform('EPSG:4326', 'EPSG:3857');

    let feature = new Feature(polyline);
    feature.setStyle([
      new Style({
        stroke: new Stroke({
          color: 'rgba(0, 0, 128, 0.7)',
          width: 5,
        })
      })
    ]);
    this.features.addFeature(feature);
  }

  renderMarkers() {
    for (const [_, report] of this.props.reports.entries()) {
      let marker = new Feature({
        geometry: new Point(fromLonLat([report.longitude, report.latitude])),
      });
      marker.setStyle([
        new Style({
          image: new Circle({
            radius: 5,
            fill: new Fill({
              color: 'rgba(255, 255, 255, 0.3)'
            }),
            stroke: new Stroke({
              color: 'rgba(0, 0, 128, 0.7)'
            })
          })
        })
      ]);
      this.features.addFeature(marker);
    }
  }

  renderFirstMarker() {
    if (this.props.reports.length > 0) {
      const report = this.props.reports[0];
      const coords = [report.longitude, report.latitude];

      let feature = new Feature({geometry: new Point(fromLonLat(coords))});
      feature.setStyle([
        new Style({
          image: new Circle({
            radius: 5,
            fill: new Fill({
              color: 'rgba(255, 255, 255, 1)'
            }),
            stroke: new Stroke({
              color: 'rgba(255, 0, 0, 1)'
            })
          })
        }),
        new Style({
          image: new Icon({
            scale: 0.5,
            rotateWithView: false,
            anchor: [0.5, 1],
            opacity: 1,
            src: '/static/gps/marker.png'
          }),
          zIndex: 5
        }),
      ]);
      this.features.addFeature(feature);
    }
  }

  render() {
    //console.log(this.props);
    this.features.clear();
    this.centerView();
    this.renderPolyline();
    this.renderMarkers();
    this.renderFirstMarker();
    return (
      <div id="map" className="map"></div>
    )
  }
}

export default Map;
